import superagent from 'superagent'
import Promise from 'promise'

let config = require('config');

let API_URL = "https://uoc.uoc.world/api/v1/post-covid-society"
let API_KEY = "28d4b502-a5ba-4b44-87a0-7349afe6ab4c"

export const FETCH_POSTS       = 'FETCH_POSTS'
export const FETCH_SINGLE_POST = 'FETCH_SINGLE_POST'
export const GET_POSTS         = 'GET_POSTS'
export const GET_SINGLE_POST   = 'GET_SINGLE_POST'

export const SAVE_LOCAL = 'SAVE_LOCAL'
export const LOAD_LOCAL = 'LOAD_LOCAL'

const send = (name, res) => {
  switch (name) {
    case "fetchposts": {
      return {
        type:FETCH_POSTS
      }
    } break;
    case "fetchsinglepost": {
      return {
        type:FETCH_SINGLE_POST
      }
    } break;
    case "getposts": {
      return {
        type:GET_POSTS,
        body:res.body
      }
    } break;
    case "getsinglepost": {
      return {
        type:GET_SINGLE_POST,
        body:res.body
      }
    } break;
  }
}

export const getPosts = () => {
  return dispatch => {
    return new Promise(() => {
      dispatch(send('fetchposts', null))
      var url = API_URL + "?limit=" + 9999 + "&fields=title,artist,tag,id,islink,updatedAt"
      superagent
      .get(url)
      .set('X-API-Key', API_KEY)
      .end((err, res) => {
        if (err) {
        }
        dispatch(send("getposts", res))
      })
    })
  }
}

export const getSingleById = (id, draft = "") => {
  return dispatch => {
    return new Promise(() => {
      dispatch(send('fetchsinglepost', null))
      var url = API_URL + "/" + id
      if (draft != "") {
        url = API_URL + "/" + id + "?draftKey=" + draft
      }
      superagent
      .get(url)
      .set('X-API-Key', API_KEY)
      .end((err, res) => {
        if (err) {
        }
        dispatch(send("getsinglepost", res))
      })
    })
  }
}

export const saveLocal = (id, updateAt) => {
  if (updateAt == null) {
    updateAt = ""
  }
  var local = localStorage.getItem('uoc');
  if (local) {
    local = JSON.parse(local);
  } else {
    local = []
  }
  var isFound = false
  for (var i = 0; i < local.length; i++) {
    if (id == local[i].split("___")[0]) {
      isFound = true
    }
  }
  if (!isFound) {
    local.push(id + "___" + updateAt)
    localStorage.setItem('uoc', JSON.stringify(local));
  }
  return {
    type:SAVE_LOCAL
  }
}

export const loadLocal = () => {
  var local = localStorage.getItem('uoc');
  var json
  if (local) {
    json = JSON.parse(local);
  } else {
    json = []
  }
  return {
    type:LOAD_LOCAL,
    local:json
  }
}

export const checkLocal = (posts) => {
  var local = localStorage.getItem('uoc');
  var json
  if (local) {
    json = JSON.parse(local);
    for (var i = 0; i < posts.contents.length; i ++) {
      var post = posts.contents[i]
      for (var j = 0; j < json.length; j ++) {
        var lc = json[j]
        var lcId = lc.split("___")[0]
        var lcUpdate = lc.split("___")[1]
        if (post.id == lcId) {
          if (lcUpdate != post.updatedAt) {
            json.splice(j, 1)
          }
        }
      }
    }

    localStorage.setItem('uoc', JSON.stringify(json));
  }
  return {
    type:LOAD_LOCAL,
    local:json
  }
}



// WEBPACK FOOTER //
// ./src/actions/const.js